import React from 'react';
import Spacing from '../../Spacing';
import { pageTitle } from '../../../helpers/PageTitle';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import AvatarSelector from '../../AvatarSelector';
import { getRandomAvatar } from '../../../utils/avatars';

export default function Register() {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [data, setData] = React.useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    rePassword: '',
    avatar: getRandomAvatar().id,
    TOS: false,
  });
  const [error, setError] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  async function submitForm(e) {
    e.preventDefault();
    setError('');

    // Validation
    if (!data.TOS) {
      setError('You must agree to the terms of service and privacy policy');
      return;
    }

    if (data.password !== data.rePassword) {
      setError('Passwords do not match');
      return;
    }

    if (data.password.length < 8) {
      setError('Password must be at least 8 characters long');
      return;
    }

    setLoading(true);

    try {
      await register({
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        password: data.password,
        avatar: data.avatar,
      });

      setData({
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        rePassword: '',
        avatar: getRandomAvatar().id,
        TOS: false,
      });

      alert('Registration successful! You can now log in with your credentials.');
      navigate('/login');
    } catch (err) {
      setError(err.message || 'Registration failed. Please try again.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }
  
  pageTitle('Mobile App Development');
  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <Spacing lg="75" md="60" />
      <div style={{ display: 'flex', justifyContent: 'center'}}>
        <div style={{ backgroundColor: 'rgba(79, 71, 71, 0.1)', padding: '2rem', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <img style={{ height: '150px'}} src="https://res.cloudinary.com/dam8havko/image/upload/v1713329245/Group_6_yr8w4j.svg" alt="Digitalbyte Login" />
          <h2 style={{ textAlign: 'center', marginTop: '1rem'}} className="cs_section_title cs_fs_20 mb-0">Register</h2>
          {error && (
            <div style={{ color: 'red', textAlign: 'center', marginTop: '1rem', padding: '0.5rem', backgroundColor: 'rgba(255, 0, 0, 0.1)', borderRadius: '4px' }}>
              {error}
            </div>
          )}
          <form style={{ display: 'flex', flexDirection: 'column', width: '400px' }} onSubmit={(e) => submitForm(e)}>
            <label className="cs_fs_12 cs_semibold cs_primary_color">
              First Name
            </label>
            <input
              required
              onChange={(e) => setData({...data, firstName: e.target.value})}
              value={data.firstName}
              placeholder="Type your first name"
              type="text"
              className="cs_form_field"
            />
            <div className="cs_height_38 cs_height_lg_25" />
            <label className="cs_fs_12 cs_semibold cs_primary_color">
              Last Name
            </label>
            <input
              required
              onChange={(e) => setData({...data, lastName: e.target.value})}
              value={data.lastName}
              placeholder="Type your last name"
              type="text"
              className="cs_form_field"
            />
             <div className="cs_height_38 cs_height_lg_25" />
            <label className="cs_fs_12 cs_semibold cs_primary_color">
              Email
            </label>
            <input
              required
              onChange={(e) => setData({...data, email: e.target.value})}
              value={data.email}
              placeholder="Type your email"
              type="email"
              className="cs_form_field"
            />
            <div className="cs_height_38 cs_height_lg_25" />
            <label className="cs_fs_12 cs_semibold cs_primary_color">
              Password
            </label>
            <input
              required
              onChange={(e) => setData({...data, password: e.target.value})}
              value={data.password}
              placeholder="Type your password (min 8 characters)"
              type="password"
              className="cs_form_field"
            />
            <div className="cs_height_38 cs_height_lg_25" />
            <label className="cs_fs_12 cs_semibold cs_primary_color">
              Re-Type Password
            </label>
            <input
              required
              onChange={(e) => setData({...data, rePassword: e.target.value})}
              value={data.rePassword}
              placeholder="Type your password again"
              type="password"
              className="cs_form_field"
            />
            <div className="cs_height_38 cs_height_lg_25" />
            <label className="cs_fs_12 cs_semibold cs_primary_color">
              Choose Your Avatar
            </label>
            <AvatarSelector
              selectedAvatar={data.avatar}
              onSelect={(avatarId) => setData({...data, avatar: avatarId})}
            />
            <div className="cs_height_14 cs_height_lg_25" />
            <label style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
              <input style={{ marginRight: '.25rem' }} type="checkbox" checked={data.TOS} onChange={() => setData({...data, TOS: !data.TOS})} required />
              <NavLink style={{ color: '#5625D8'}} to='/'>Agree to terms of service and  privacy policy</NavLink>.
            </label>
            <div className="cs_height_14 cs_height_lg_25" />
            <button type="submit" className="cs_btn cs_style_1" disabled={loading}>
              {loading ? 'Signing Up...' : 'Sign Up'}
            </button>
            <p style={{ textAlign: 'center', marginTop: '1rem' }}>Already have an account? Login <NavLink to="/login" style={{ color: '#5625D8'}}>here</NavLink>!</p>
          </form>
        </div>
      </div>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <Spacing lg="75" md="60" />
    </>
  );
}
